import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { Container, Block } from './styles/_bottom';
import FacilityDetails from '../common/_facilityDetails';

@observer
class Bottom extends Component {
  render() {
    return (
      <Container>
        <Block>
          <FacilityDetails style={{ background: 'white' }} />
        </Block>
      </Container>
    );
  }
}

export default Bottom;
